var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandingShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3922 4.53405C21.1807 4.23849 22.0496 4.23849 22.8381 4.53405L35.0326 9.10699C35.6969 9.35599 36.2693 9.80183 36.6734 10.3849C37.0774 10.968 37.2939 11.6605 37.2938 12.3699V21.7126C37.2939 24.6244 36.4831 27.4786 34.9524 29.9555C33.4216 32.4324 31.2313 34.4341 28.627 35.7363L22.7841 38.656C22.4212 38.8375 22.021 38.932 21.6152 38.932C21.2094 38.932 20.8092 38.8375 20.4462 38.656L14.6033 35.7346C11.999 34.4324 9.80874 32.4307 8.27799 29.9538C6.74723 27.4769 5.93646 24.6226 5.93652 21.7109V12.3716C5.93608 11.6619 6.15238 10.969 6.55647 10.3856C6.96057 9.8022 7.53319 9.3561 8.19773 9.10699L20.3922 4.53405ZM23.3572 21.1482C24.0214 20.7647 24.5405 20.1727 24.834 19.4642C25.1275 18.7556 25.1789 17.97 24.9804 17.2292C24.7819 16.4883 24.3445 15.8337 23.7361 15.3668C23.1276 14.8999 22.3821 14.6468 21.6152 14.6468C20.8482 14.6468 20.1027 14.8999 19.4943 15.3668C18.8858 15.8337 18.4484 16.4883 18.2499 17.2292C18.0514 17.97 18.1029 18.7556 18.3964 19.4642C18.6898 20.1727 19.2089 20.7647 19.8731 21.1482V26.8413C19.8731 27.3033 20.0566 27.7464 20.3833 28.0731C20.71 28.3998 21.1531 28.5834 21.6152 28.5834C22.0772 28.5834 22.5203 28.3998 22.847 28.0731C23.1737 27.7464 23.3572 27.3033 23.3572 26.8413V21.1482Z",
    fill: "#FEBA05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingShield);
export default __webpack_public_path__ + "static/media/landing_shield.ba18a069a4424f64cc32d88e792b58b5.svg";
export { ForwardRef as ReactComponent };